import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import { apiPut } from "../../API/Api_Url";

function FreelancerUpdateJobPostDataModal({ isOpen, onClose, JobPostData, setExpandedJob, GetAllPendingJobs }) {
    const [proposedPrice, setProposedPrice] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [note, setNote] = useState("");
    const [IsLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (JobPostData) {
            setProposedPrice(JobPostData?.ProposedPrice || "");
            setStartDate(
                JobPostData?.Timeline?.startDate
                    ? new Date(JobPostData?.Timeline?.startDate).toISOString().split("T")[0]
                    : ""
            );
            setEndDate(
                JobPostData?.Timeline?.endDate
                    ? new Date(JobPostData?.Timeline?.endDate).toISOString().split("T")[0]
                    : ""
            );
            setNote(JobPostData?.Note || "");
        }
    }, [JobPostData]);


    const handleSubmit = async () => {
        let newErrors = {};
        if (!proposedPrice) newErrors.proposedPrice = "Proposed price is required";
        if (!startDate) newErrors.startDate = "startDate is required";
        if (!endDate) newErrors.endDate = "End date is required";
        if (!note) newErrors.note = "note is required";

        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        try {
            setIsLoading(true);
            const payload = {
                ProposedPrice: Number(proposedPrice),
                Timeline: {
                    startDate: startDate,
                    endDate: endDate,
                },
                Note: note,
            };

            const response = await apiPut(
                `api/freelance-engineer/UpdateBidOnJobPost/${JobPostData?._id}`,
                payload
            );

            if (response?.data) {
                toast.success(response?.message || "Bid Updated successfully!");
                onClose();
                setExpandedJob(null);
                GetAllPendingJobs();
            } else {
                toast.error(response?.message || "Failed to submit bid");
            }
        } catch (error) {
            console.error("Error submitting bid:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };


    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-xl shadow-lg w-full max-w-lg p-6 relative">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                >
                    <FaTimes className="h-5 w-5" />
                </button>

                <h2 className="text-xl font-semibold text-gray-800 mb-4">
                    Update My JobPostData
                </h2>

                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Proposed Price (₹)
                        </label>
                        <input
                            type="number"
                            value={proposedPrice}
                            onChange={(e) => setProposedPrice(e.target.value)}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            required
                        />
                        {errors?.proposedPrice && (
                            <p className="text-red-500 text-sm mt-1">{errors?.proposedPrice}</p>
                        )}
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Start Date
                            </label>
                            <input
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                required
                            />
                            {errors?.startDate && (
                                <p className="text-red-500 text-sm mt-1">{errors?.startDate}</p>
                            )}

                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                End Date
                            </label>
                            <input
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                required
                            />
                            {errors?.endDate && (
                                <p className="text-red-500 text-sm mt-1">{errors?.endDate}</p>
                            )}
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Note
                        </label>
                        <textarea
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                            rows="4"
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            placeholder="Add your proposal note here..."
                            required
                        ></textarea>
                        {errors.note && (
                            <p className="text-red-500 text-sm mt-1">{errors?.note}</p>
                        )}
                    </div>

                    <div className="flex justify-end gap-3">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 rounded-lg border text-gray-600 hover:bg-gray-100 transition"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={() => { handleSubmit() }}
                            className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition"
                        >
                            {IsLoading ? 'Please Wait' : 'Update JobPostData'}

                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FreelancerUpdateJobPostDataModal;
